const que = [
    {
      "question": "What type of main character do you prefer?",
      "img":"/reincarnation/1.webp",
      "OPTIONS": {
        "A": "A brave adventurer.",
        "B": "A dedicated warrior.",
        "C": "A modern student with hidden powers.",
        "D": "A powerful mage or fantasy hero.",
        "E": "A survivor in a dystopian world."
      }
    },
    {
      "question": "What kind of setting do you find most appealing?",
      "img":"/reincarnation/2.jpg",
      "OPTIONS": {
        "A": "Expansive seas and islands.",
        "B": "Ancient or feudal Japan.",
        "C": "Modern-day cities with a twist.",
        "D": "Magical kingdoms and mystical realms.",
        "E": "Futuristic cities or post-apocalyptic landscapes."
      }
    },
    {
      "question": "What kind of adventure excites you?",
      "img":"/reincarnation/3.avif",
      "OPTIONS": {
        "A": "Exploring uncharted territories.",
        "B": "Engaging in epic battles and training to become stronger.",
        "C": "Discovering supernatural powers in everyday life.",
        "D": "Embarking on quests filled with magic and wonder.",
        "E": "Surviving against overwhelming odds in a harsh world."
      }
    },
    {
      "question": "How do you prefer conflicts to be resolved?",
      "img":"/reincarnation/4.png",
      "OPTIONS": {
        "A": "With daring and clever tactics.",
        "B": "Through intense training and powerful techniques.",
        "C": "By uncovering hidden strengths and teamwork.",
        "D": "With the help of magic and mythical allies.",
        "E": "By rebelling and fighting for survival."
      }
    },
    {
      "question": "What type of storyline keeps you hooked?",
      "img":"/reincarnation/5.avif",
      "OPTIONS": {
        "A": "Epic journeys and legendary quests.",
        "B": "Heroic battles and personal growth.",
        "C": "Everyday life mixed with supernatural elements.",
        "D": "Magical adventures and enchanted discoveries.",
        "E": "Dark and gritty tales of survival and resistance."
      }
    },
    {
      "question": "Which kind of side characters do you enjoy the most?",
      "img":"/reincarnation/6.avif",
      "OPTIONS": {
        "A": "Diverse team members or fellow adventurers.",
        "B": "Loyal comrades and fierce rivals.",
        "C": "Friends and classmates with unique powers.",
        "D": "Magical beings and fantasy creatures.",
        "E": "Survivors, rebels, and unexpected allies."
      }
    },
    {
      "question": "What kind of animation style do you prefer?",
      "img":"/reincarnation/7.avif",
      "OPTIONS": {
        "A": "Bright and colorful with detailed environments.",
        "B": "Rich and dynamic with a touch of tradition.",
        "C": "Modern and clean with a focus on characters.",
        "D": "Vibrant and fantastical with magical effects.",
        "E": "Dark and intense with a realistic touch."
      }
    },
    {
      "question": "Which theme resonates most with you?",
      "img":"/reincarnation/8.webp",
      "OPTIONS": {
        "A": "Freedom and adventure.",
        "B": "Honor and perseverance.",
        "C": "Self-discovery and friendship.",
        "D": "Magic and destiny.",
        "E": "Survival and resistance."
      }
    },
    {
      "question": "What type of world-building do you appreciate the most?",
      "img":"/reincarnation/9.png",
      "OPTIONS": {
        "A": "Expansive and diverse, with lots of places to explore.",
        "B": "Deeply rooted in history and culture.",
        "C": "A mix of the familiar and the fantastical.",
        "D": "Rich and intricate with magical lore.",
        "E": "Detailed and immersive, often with a dark tone."
      }
    },
    {
      "question": "How do you feel about the use of technology in anime?",
      "img":"/reincarnation/10.avif",
      "OPTIONS": {
        "A": "Technology should be advanced and innovative.",
        "B": "Prefer minimal or historical technology.",
        "C": "A balance of modern tech and traditional elements.",
        "D": "Magical tools over technology.",
        "E": "High-tech and essential for survival."
      }
    },
    {
      "question": "Which type of antagonist do you find most compelling?",
      "img":"/reincarnation/11.avif",
      "OPTIONS": {
        "A": "Rival adventurers or corrupt leaders.",
        "B": "Powerful enemies or dark forces.",
        "C": "Supernatural beings or internal conflicts.",
        "D": "Dark wizards or malevolent spirits.",
        "E": "Oppressive regimes or monstrous threats."
      }
    },
    {
      "question": "What kind of humor do you enjoy in anime?",
      "img":"/reincarnation/12.avif",
      "OPTIONS": {
        "A": "Playful and adventurous with a sense of fun.",
        "B": "Heroic banter and occasional comic relief.",
        "C": "Light-hearted and everyday humor.",
        "D": "Magical mishaps and fantasy fun.",
        "E": "Dark humor with a touch of irony."
      }
    },
    {
      "question": "How do you like romance to be handled in anime?",
      "img":"/reincarnation/13.avif",
      "OPTIONS": {
        "A": "Subtle and part of the grand adventure.",
        "B": "Dramatic and intertwined with heroic deeds.",
        "C": "Central to the story with relatable moments.",
        "D": "Enchanted and deeply emotional.",
        "E": "Secondary to the main plot, often tragic."
      }
    },
    {
      "question": "What kind of music do you prefer in anime openings and endings?",
      "img":"/reincarnation/14.jpeg",
      "OPTIONS": {
        "A": "Energetic and adventurous tunes.",
        "B": "Epic and orchestral with a sense of grandeur.",
        "C": "Catchy and modern with a pop/rock feel.",
        "D": "Mystical and enchanting melodies.",
        "E": "Intense and dramatic compositions."
      }
    },
    {
      "question": "Which type of character development do you enjoy?",
      "img":"/reincarnation/15.avif",
      "OPTIONS": {
        "A": "Growth through adventure and discovery.",
        "B": "Becoming stronger and facing great challenges.",
        "C": "Evolving through everyday experiences.",
        "D": "Uncovering magical powers and destinies.",
        "E": "Surviving and fighting against the odds."
      }
    },
    {
      "question": "What kind of emotional tone do you like in anime?",
      "img":"/reincarnation/16.jpg",
      "OPTIONS": {
        "A": "Exciting and filled with hope.",
        "B": "Inspiring and full of heroic moments.",
        "C": "Warm and relatable with a mix of emotions.",
        "D": "Whimsical and filled with wonder.",
        "E": "Dark and intense with moments of relief."
      }
    },
    {
      "question": "Which type of relationships do you enjoy seeing in anime?",
      "img":"/reincarnation/17.webp",
      "OPTIONS": {
        "A": "Crews or teams working together.",
        "B": "Allies and comrades in epic battles.",
        "C": "Friends and families navigating life.",
        "D": "Magical bonds and enchanted connections.",
        "E": "Survivors and rebels forming strong bonds."
      }
    },
    {
      "question": "What type of challenges do you find most exciting?",
      "img":"/reincarnation/18.avif",
      "OPTIONS": {
        "A": "Treasure hunts and sea battles.",
        "B": "Ninja battles and intense training arcs.",
        "C": "Balancing everyday life with supernatural challenges.",
        "D": "Magical trials and epic quests.",
        "E": "Fighting against oppressive forces and monsters."
      }
    },
    {
      "question":"What type of villains do you find most compelling?",
      "img":"/reincarnation/19.webp",
      "OPTIONS":{
        "A":"Rogue adventurers.",
        "B":"Legendary warriors.",
        "C":"Every day people with secrets.",
        "D":"Magical creature and dark sorcerers.",
        "E":"Dictators or AI lords."
      }
    },
    {
      "question": "Which kind of ending do you prefer?",
      "img":"/reincarnation/20.avif",
      "OPTIONS": {
        "A": "Open-ended with possibilities for more adventures.",
        "B": "Conclusive with a sense of victory and growth.",
        "C": "Resolution with emotional satisfaction.",
        "D": "Magical and fulfilling with a touch of wonder.",
        "E": "Bittersweet or leaving room for thought."
      }
    },
    {
      "question": "What type of legacy would you like the characters to leave behind?",
      "img":"/reincarnation/21.avif",
      "OPTIONS": {
        "A": "Legendary tales known across the world.",
        "B": "Heroic deeds and stories of courage.",
        "C": "Meaningful relationships and personal growth.",
        "D": "Epic sagas of magic and destiny.",
        "E": "Inspiring tales of survival and rebellion."
      }
    }
  ]

  export default que;